import React, { Component } from 'react';

class Testimonials extends Component {
  render() {

    if(this.props.data){
      var testimonials = this.props.data.testimonials.map(function(testimonials){
        return  <li key={testimonials.user}>
            <blockquote>
               <p>{testimonials.text}</p>
               <p>{testimonials.text1}</p>
               <p>{testimonials.text2}</p>
               <p>{testimonials.text3}</p>
               <p>{testimonials.text4}</p>
               <p>{testimonials.text5}</p>
            </blockquote>
         </li>
      })
    }

    return (
      <section id="testimonials">
      <div className="text-container">
         <div className="row">

            <div className="twelve columns header-col">
               <h1 align="center"><span>Achievements</span></h1>
            
            <ul>
            <li> &nbsp;  CODECHEF :  Highest Rating - 4 * (1862 pts)</li>
            <li> &nbsp;Ranked 5th / 30K participants in  Codechef December Long Challenge 2022</li>            
            <li> &nbsp; HACKERRANK : Highest Rating - 5* @ (Problem Solving)</li>
            <li> &nbsp;Skill Certification in Problem Solving, Java, Python, SQL by HACKERRANK</li>
            <li> &nbsp;Smart India Hackathon 2022 Internal Round - 1st Runner Up</li>
            </ul>
            </div>
            
            </div>
         </div>
   </section>
    );
  }
}

export default Testimonials;
